import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {inject, observer} from 'mobx-react';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';
import Alert from 'spa/Components/Alert';
import LoadingIndicator from 'spa/Components/LoadingIndicator';

import plus from 'spa/images/icons/plus.svg';
import paypalWhite from 'spa/images/icons/paypalwhite.svg';
import { PAYMENT_TYPES } from '../../state/payments/billing';

@inject(({
  store: {
    billing,
    notifications,
  },
}) =>
  ({
    billing,
    notifications,
  }))
@observer
@withI18n
class CheckoutNewPaypalForm extends React.Component {
  static propTypes = {
    billing: PropTypes.shape({
      closePaypal: PropTypes.func,
      loadPaymentMethods: PropTypes.func,
      tokenizePaypal: PropTypes.func,
      tokenizePaypalOld: PropTypes.func,
      resetPaypal: PropTypes.func,
      isDoingPaypal: PropTypes.bool,
      paypalError: PropTypes.object,
      paypalGatewayReady: PropTypes.string,
    }),
    countryId: PropTypes.string.isRequired,
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
    }),
    paymentInfo: PropTypes.shape({
      paymentOption: PropTypes.string,
      paymentToken: PropTypes.string,
    }).isRequired,
    isFirst: PropTypes.bool.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.props.billing.resetPaypal();
  }

  componentWillUnmount() {
    this.props.billing.closePaypal();
  }

  @autobind @action onClickSelect(event) {
    event.preventDefault();
    const {paymentInfo} = this.props;

    paymentInfo.paymentOption = PAYMENT_TYPES.PAYPAL;
    paymentInfo.paymentToken = '';
  }

  @autobind @action onClickAddNew(event) {
    event.preventDefault();
    const {
      billing,
      countryId,
      notifications,
      paymentInfo,
    } = this.props;

    paymentInfo.paymentOption = PAYMENT_TYPES.PAYPAL;
    paymentInfo.paymentToken = '';

    billing.tokenizePaypal(countryId)
      .then((response) => {
        paymentInfo.paymentToken = response.paymentMethod_id;
        billing.loadPaymentMethods();
      }).catch((error) => {
        notifications.add({
          id: 'add-paypal-error',
          type: 'error',
          title: this.context.i18n.__error(error),
        });
      });
  }

  @autobind @action onClickRetry(event) {
    event.preventDefault();
    const {billing, paymentInfo} = this.props;

    paymentInfo.paymentOption = 'paypal';
    paymentInfo.paymentToken = '';

    billing.tokenizePaypal();
  }

  @autobind @action onClickRemove(event) {
    event.preventDefault();
    this.props.billing.resetPaypal();
  }

  render() {
    const {i18n} = this.context;
    const {
      billing, isFirst, paymentInfo,
    } = this.props;

    const {isDoingPaypal, paypalError} = billing;

    if (isDoingPaypal) {
      return <LoadingIndicator className="checkout-payment-details__loading-indicator" />;
    }

    let message;
    let button;
    if (paypalError) {
      message = <Alert key="paypal-connect-error" type="error" title={i18n.__error(paypalError)} onClick={this.onClickRetry} />;
    }
    if (isFirst) {
      button = (
        <a
          key="connect-paypal-button"
          href="#"
          onClick={this.onClickAddNew}
          className="checkout-payment-details__payment-paypal"
        >
          {i18n.__react('Connect your %(paypal)s account', {
            paypal: <img src={paypalWhite} alt="" />,
          })}
        </a>
      );
    } else {
      button = (
        <a
          key="connect-paypal-button"
          href="#"
          onClick={this.onClickAddNew}
          className="checkout-payment-details__payment-method checkout-payment-details__payment-method--no-border-bottom"
        >
          <span className="checkout-payment-details__payment-method-icon">
            <img src={plus} alt="" />
          </span>
          <span className="checkout-payment-details__payment-method-label checkout-payment-details__payment-method-label">{i18n._x('Add new PayPal account', 'Checkout New Paypal form')}</span>
        </a>
      );
    }

    return (
      <div>
        {billing.paypalGatewayReady ? (
          [
            button,
            message,
          ]
        ) : (
          <p className="checkout-payment-details__loading-paypal-info">
            {i18n._x('Loading PayPal...', 'Checkout payment methods')}
          </p>
        )}

      </div>
    );
  }
}

export default CheckoutNewPaypalForm;



// WEBPACK FOOTER //
// ./spa/Components/CheckoutPaymentDetails/CheckoutNewPaypalForm.jsx